// WhatsApp helper. Phone in international format without "+" or spaces.
export const WHATSAPP_PHONE = "918208805487"; // +91 82088 05487

export function buildProductMessage(product, qty = 1) {
  const lines = [
    `Hi Organo Mushroom 👋`,
    ``,
    `I'd like to order:`,
    `• ${qty} × ${product.name} (${product.weight}) — ₹${product.price * qty}`,
    ``,
    `Could you please confirm availability and delivery?`,
  ];
  return lines.join("\n");
}

export function buildCartMessage(items, subtotal) {
  if (!items || items.length === 0) return "";
  const lines = [
    `Hi Organo Mushroom 👋`,
    ``,
    `I'd like to place this order:`,
    ...items.map(
      (i) => `• ${i.qty} × ${i.name} (${i.weight}) — ₹${i.price * i.qty}`
    ),
    ``,
    `Subtotal: ₹${subtotal}`,
    ``,
    `Could you please confirm availability and delivery?`,
  ];
  return lines.join("\n");
}

export function whatsappLink(message) {
  const text = encodeURIComponent(message);
  return `https://wa.me/${WHATSAPP_PHONE}?text=${text}`;
}
